import { useTranslation } from 'react-i18next';
import SystemPanel from '../components/SystemPanel';

const SystemTab = ({ serverHealth, projects, shapeCountsByOrg, orgUsers, documents, onRefreshHealth }) => {
  const { t } = useTranslation();

  return (
    <SystemPanel
      serverHealth={serverHealth}
      orgProjects={projects}
      orgShapeCounts={shapeCountsByOrg}
      orgUsers={orgUsers}
      documents={documents}
      t={t}
      onRefreshHealth={onRefreshHealth}
    />
  );
};

export default SystemTab;
